import React from 'react';

const NewProjectLaunch = ({ newLaunch, agent }) => {
  const whatsappUrl = `https://wa.me/${agent?.whatsappNumber || '60163288120'}?text=Hi%20Nicole,%20I'd%20like%20to%20learn%20more%20about%20the%20new%20launch%20The%20Peak%20@%20Horizon%20Hills`;

  return (
    <div id="new-launch">
      <div className="section-header">
        <h2 className="section-title">NEW PROJECT LAUNCH</h2>
        <a href="#new-launch" className="link-view-all">
          VIEW ALL PROJECTS <i className="bi bi-arrow-right"></i>
        </a>
      </div>

      <div className="new-launch-card">
        <div className="launch-image-container">
          <img src={newLaunch?.imageUrl || "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80"} alt={newLaunch?.title} className="launch-image" />
          <span className="launch-badge">{newLaunch?.tag || "NEW LAUNCH"}</span>
        </div>
        <div className="launch-content">
          <h3 className="launch-title">{newLaunch?.title || "The Peak @ Horizon Hills"}</h3>
          <div className="launch-price">{newLaunch?.priceRange || "Starting From RM 1.4 Million"}</div>
          <ul className="launch-features">
            {newLaunch?.features ? (
              newLaunch.features.map((feature, index) => (
                <li key={index}>
                  <i className="bi bi-check-circle-fill"></i> {feature}
                </li>
              ))
            ) : (
              <>
                <li><i className="bi bi-check-circle-fill"></i> Freehold</li>
                <li><i className="bi bi-check-circle-fill"></i> Gated & Guarded</li>
                <li><i className="bi bi-check-circle-fill"></i> Luxury Facilities</li>
              </>
            )}
          </ul>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-learn-more" style={{ textDecoration: 'none' }}>
            LEARN MORE
          </a>

          <div className="launch-dots">
            <span className="launch-dot active"></span>
            <span className="launch-dot"></span>
            <span className="launch-dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProjectLaunch;
